import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

interface SectionHeadingProps {
  title: string;
  icon?: string;
  moreTo?: string;
  moreLabel?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  title,
  icon = 'ri-newspaper-line',
  moreTo,
  moreLabel = '查看更多',
  children,
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-center justify-between border-b-2 border-primary-100 pb-3">
      <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950 md:text-xl">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-600 text-background-50">
          <i className={`${icon} text-lg`}></i>
        </span>
        {title}
      </h2>
      <div className="flex items-center gap-3">
        {children}
        {moreTo && (
          <Link
            to={moreTo}
            className="flex items-center gap-0.5 whitespace-nowrap text-sm text-foreground-500 transition-colors hover:text-primary-600"
          >
            {moreLabel}
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        )}
      </div>
    </div>
  );
}